export const GET_REPORTS = "GET";
export const GET_REPORTS_SORT_LIST = "GET_REPORTS_SORT_LIST";
